import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';

export interface LeadAlerta {
  id: number;
  nombre: string;
  telefono?: string | null;
  clasificacion?: string | null;
  estado: string;
  zona?: string | null;
  proximoFollowupAt?: string | null;
  /** Horas vencidas (en `vencidos`) o que faltan (en `porVencer`). */
  horas?: number | null;
}

export interface MisAlertasLeadsResponse {
  vencidos: LeadAlerta[];
  porVencer: LeadAlerta[];
  sinAsignar: LeadAlerta[];
  /** Míos, sin contactar y sin cadencia corriendo. Un lead llega acá cuando se le
   * agota la cadencia sin que nadie lo mueva, o cuando se asigna sin arrancarla
   * (el espejo de la titularidad de Metrocuadrado). Antes no salía en ninguna
   * lista: tener dueño lo excluía de `sinAsignar`, y no tener plazo lo excluía de
   * las otras dos. */
  sinGestionar: LeadAlerta[];
  /** Visitaron (o la cita ya pasó) y nadie registró qué ocurrió. El registro de
   * visita es opcional por decisión de David (09/10/2026): no bloquea ninguna
   * transición, así que el faltante se publica acá o se pierde en silencio. */
  visitasSinRegistrar: LeadAlerta[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class AlertasLeadsService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiUrl;

  misAlertas(): Observable<MisAlertasLeadsResponse> {
    return this.http.get<MisAlertasLeadsResponse>(`${this.base}/leads/mis-alertas`);
  }
}
